import { Clock, Euro } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const ServiceCard = ({ service, showBookButton = true }) => {
  return (
    <div 
      className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300 border border-sand service-card"
      data-testid={`service-card-${service.id}`}
    >
      <div className="flex flex-col h-full">
        {/* Category badge */}
        <span className={`self-start px-3 py-1 rounded-full text-xs font-body font-medium mb-3 ${
          service.category === 'massage' 
            ? 'bg-terracotta-100 text-terracotta-700'
            : service.category === 'naturopathie'
            ? 'bg-sage-100 text-sage-700'
            : 'bg-gold/20 text-warm-brown'
        }`}>
          {service.category === 'massage' ? 'Massage' : 
           service.category === 'naturopathie' ? 'Naturopathie' : 'Activité'}
        </span>

        {/* Title */}
        <h3 className="font-heading text-xl font-semibold text-warm-brown mb-2">
          {service.name}
        </h3>

        {/* Description */}
        <p className="font-body text-warm-brown-light text-sm leading-relaxed mb-4 flex-grow">
          {service.description}
        </p>

        {/* Duration & Price */}
        <div className="flex items-center justify-between mb-4 pt-4 border-t border-sand">
          <div className="flex items-center gap-2 text-sage-700">
            <Clock size={16} />
            <span className="font-body text-sm">{service.duration} min</span>
          </div>
          <div className="flex items-center gap-1 text-terracotta font-semibold">
            <span className="font-heading text-xl">{service.price}</span>
            <Euro size={16} />
          </div>
        </div>

        {/* Book button */}
        {showBookButton && service.price > 0 && (
          <Link to={`/reservation?service=${service.id}`} className="w-full">
            <Button 
              className="w-full bg-terracotta hover:bg-terracotta-600 text-white rounded-full font-body"
              data-testid={`book-service-${service.id}`}
            >
              Réserver
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default ServiceCard;
